var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.44 0c33.93 0 61.44 27.51 61.44 61.44 0 33.93-27.51 61.44-61.44 61.44C27.51 122.88 0 95.37 0 61.44 0 27.51 27.51 0 61.44 0zm-8.52 30.52h7.51c1.37 0 2.5 1.13 2.5 2.5v28.94h26.41c1.38 0 2.5 1.13 2.5 2.5v7.51c0 1.38-1.13 2.5-2.5 2.5H50.41V33.02c0-1.38 1.13-2.5 2.51-2.5zm8.52-16.57c26.23 0 47.49 21.26 47.49 47.49s-21.26 47.49-47.49 47.49-47.49-21.26-47.49-47.49c0-26.22 21.26-47.49 47.49-47.49z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
export default SvgClockIcon;